import script from "./Roles.vue?vue&type=script&setup=true&lang=js"
export * from "./Roles.vue?vue&type=script&setup=true&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=6aadea30&lang=css"

const __exports__ = script;

export default __exports__